import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { EmailMessageTemplateModel } from '@smarttask-common/src/lib/models/Integrations/Email/EmailMessageTemplateModel';

export enum EmailMessageTemplateActionTypes {
    ADD_EMAIL_MESSAGE_TEMPLATE = '[EmailMessageTemplate] Create EmailMessageTemplate',
    ADD_EMAIL_MESSAGE_TEMPLATES = '[EmailMessageTemplate] Add EmailMessageTemplates',
    UPSERT_EMAIL_MESSAGE_TEMPLATE = '[EmailMessageTemplate] Upsert EmailMessageTemplate',
    UPSERT_EMAIL_MESSAGE_TEMPLATES = '[EmailMessageTemplate] Upsert EmailMessageTemplates',
    UPDATE_EMAIL_MESSAGE_TEMPLATE = '[EmailMessageTemplate] Update EmailMessageTemplate',
    UPDATE_EMAIL_MESSAGE_TEMPLATES = '[EmailMessageTemplate] Update EmailMessageTemplates',
    DELETE_EMAIL_MESSAGE_TEMPLATE = '[EmailMessageTemplate] Delete EmailMessageTemplate',
    DELETE_EMAIL_MESSAGE_TEMPLATES = '[EmailMessageTemplate] Delete EmailMessageTemplates',
    DELETE_ALL_EMAIL_MESSAGE_TEMPLATES = '[EmailMessageTemplate] Delete All EmailMessageTemplates',
    DELETE_ALL = '[EmailMessageTemplate] Delete All',

    UPDATE_SELECTED_ID = '[EmailMessageTemplate] Update SelectedId',
}

export class UpdateSelectedTemplateId implements Action {
    readonly type = EmailMessageTemplateActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_template_id: string) {}
}

export class AddOne implements Action {
    readonly type = EmailMessageTemplateActionTypes.ADD_EMAIL_MESSAGE_TEMPLATE;
    constructor(public template: EmailMessageTemplateModel) {}
}

export class AddMany implements Action {
    readonly type = EmailMessageTemplateActionTypes.ADD_EMAIL_MESSAGE_TEMPLATES;
    constructor(public templates: Array<EmailMessageTemplateModel>) {}
}

export class UpsertOne implements Action {
    readonly type = EmailMessageTemplateActionTypes.UPSERT_EMAIL_MESSAGE_TEMPLATE;

    constructor(public template: EmailMessageTemplateModel) {}
}

export class UpsertMany implements Action {
    readonly type = EmailMessageTemplateActionTypes.UPSERT_EMAIL_MESSAGE_TEMPLATES;
    constructor(public templates: Array<EmailMessageTemplateModel>) {}
}

export class UpdateOne implements Action {
    readonly type = EmailMessageTemplateActionTypes.UPDATE_EMAIL_MESSAGE_TEMPLATE;
    constructor(public template: Update<EmailMessageTemplateModel>) {}
}

export class UpdateMany implements Action {
    readonly type = EmailMessageTemplateActionTypes.UPDATE_EMAIL_MESSAGE_TEMPLATES;
    constructor(public templates: Array<Update<EmailMessageTemplateModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = EmailMessageTemplateActionTypes.DELETE_EMAIL_MESSAGE_TEMPLATE;
    constructor(public template_id: string) {}
}

export class DeleteMany implements Action {
    readonly type = EmailMessageTemplateActionTypes.DELETE_EMAIL_MESSAGE_TEMPLATES;
    constructor(public template_ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = EmailMessageTemplateActionTypes.DELETE_ALL_EMAIL_MESSAGE_TEMPLATES;
    constructor(public template_ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = EmailMessageTemplateActionTypes.DELETE_ALL;
    constructor() {}
}

export type EmailMessageTemplateActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedTemplateId;
